import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useDialogStyles = createStyles(({ theme }) => {
  return {
    box: {
      borderRadius: theme.busbud.styles.rounding.xl
    },
    content: {
      overflowX: "hidden"
    },
    title: {}
  };
});

export const useDialogTitleStyles = createStyles(({ theme }) => {
  const { breakpoints } = theme.busbud;

  return {
    root: {
      position: "relative",
      "& h2": {
        paddingTop: theme.busbud.spacing(0),
        [breakpoints.up("md")]: {
          paddingTop: theme.busbud.spacing(0.5)
        }
      },
      "&::after": {
        content: "' '",
        left: "0",
        right: "0",
        bottom: "0",
        height: "1px",
        position: "absolute",
        backgroundColor: theme.busbud.colors.border.primary.opaque,
        zIndex: 1
      }
    }
  };
});
